import { render } from "./Demographics.vue?vue&type=template&id=55b622ce"
import script from "./Demographics.vue?vue&type=script&lang=ts"
export * from "./Demographics.vue?vue&type=script&lang=ts"
script.render = render

export default script